import React from "react";
import { View, StyleSheet, Image } from "react-native";
import { defaulteventimage } from "../utils/images";
import { getSubcategoryImage } from "../utils/subcategoryImages";

const ProbeIcon = ({ eventUrl, subcategory }) => {
  return (
    <View style={styles.imageBox}>
        <Image
            style={styles.cardImg}
            source={{
              uri: eventUrl || getSubcategoryImage(subcategory) || defaulteventimage()
            }}
            resizeMode="cover"
          />
    </View>
  );
};

export default ProbeIcon;

const styles = StyleSheet.create({
  imageBox: {
    width: 55,
    height: 55,
    borderRadius: 4,
    overflow: 'hidden'
  },
  cardImg: {
    width: '100%',
    height: '100%',
  },
});
